module.exports = __webpack_public_path__ + "static/media/RA11.fcab10ef.gif";